import styled from 'styled-components';

const IndustryItem = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
  line-height: 1.63;
`;

export default IndustryItem;